// overlays/SVGOverlay.ts
export function createSVGOverlay(url: string, bounds: google.maps.LatLngBounds, map: google.maps.Map): google.maps.OverlayView {
  const DEBUG_VERBOSE = false;

  class SVGOverlay extends google.maps.OverlayView {
    private div: HTMLDivElement | null = null;

    constructor(private bounds: google.maps.LatLngBounds, map: google.maps.Map) {
      super();
      this.setMap(map);
      DEBUG_VERBOSE && console.log("SVGOverlay initialized for map", map);
    }

    onAdd() {
      this.div = document.createElement("div");
      this.div.style.borderStyle = "none";
      this.div.style.borderWidth = "0px";
      this.div.style.position = "absolute";

      fetch(url)
        .then((res) => res.text())
        .then((svgText) => {
          this.div!.innerHTML = svgText;

          const labels = this.div!.querySelectorAll(".teravalis-labels");
          labels.forEach((el) => {
            (el as HTMLElement).style.opacity = "1";
          });

          const panes = this.getPanes();
          panes?.overlayMouseTarget.appendChild(this.div!);
        })
        .catch((err) => {
          console.error("Failed to load SVG overlay:", err);
        });
    }

    draw() {
      if (!this.div) return;

      const projection = this.getProjection();
      const sw = projection.fromLatLngToDivPixel(this.bounds.getSouthWest());
      const ne = projection.fromLatLngToDivPixel(this.bounds.getNorthEast());

      if (sw && ne) {
        this.div.style.left = `${sw.x}px`;
        this.div.style.top = `${ne.y}px`;
        this.div.style.width = `${ne.x - sw.x}px`;
        this.div.style.height = `${sw.y - ne.y}px`;
      }
    }

    onRemove() {
      this.div?.parentNode?.removeChild(this.div);
      this.div = null;
    }
  }

  return new SVGOverlay(bounds, map);
}
